import React from "react";
import {
  SEO,
  PageLayout,
  AnimatedSelector,
  BackgroundImages,
  MarkdownContent,
  OutboundLink,
  FishermanIcon,
  Section,
  Accordion,
  MultipleComponentIterator,
  MultipleComponentIteratorMap,
  InternalLink,
  BasicCarousel,
  componentIterator,
  Image,
  FadeReveal,
  SlideReveal,
  BackgroundImageTeamMember,
  multipleComponentIterator,
  ReviewV2,
  CustomerReviewModal,
} from "@bluefin/components";
import { Header, Button, Grid, Card } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
  withArgs,
  withNamedArgs,
  getBusinessFiles,
} from "../utils/utils";
import {
  createServiceItemSlug,
  createServiceCategorySlug,
  createTeamMemberSlug,
} from "@bluefin/gatsby-plugin-fisherman-page-creator";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      bookingUrl,
      allFishermanBusinessMenuCategory,
      allFishermanBusinessMenuItem,
      allFishermanBusinessFile,
      allFishermanBusinessTeam,
      allFishermanBusinessLocation,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          title={fishermanBusinessWebsitePage.seoTitle}
          ogUrl={"https://www.cthair.com/"}
        />
        <PageLayout hero={false} subfooter={false} className={"home-page"}>
          <AnimatedSelector
            targetSelector={
              ".image.background::before, .image.background::after"
            }
            duration={1500}
            transitionType={"zoom"}
            transitionProps={{
              animating: { scale: 1 },
              preAnimating: { scale: 1.4 },
              serverSide: { scale: 1.4 },
            }}
            easing={"cubic-bezier(0,1,0.99,1)"}
            runPolicy={"RUN_ONCE_EVERY_VISIT"}
            animationKey={"team-hero-animation"}
          >
            <BackgroundImages
              images={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentName: "HeroElement",
              })}
              parentClassName={"hero-container"}
              imageClassName={"hero-image overlay"}
              carouselProps={{
                leftArrowIcon: "arrow-left",
                rightArrowIcon: "arrow-right",
              }}
              imageProps={{ loadStrategy: "eager" }}
            >
              <Header
                as={"h1"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "home_hero_header",
                  defaultValue: "Home",
                })}
              />
              <MarkdownContent
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "home_hero_description",
                  defaultValue:
                    "The ultimate destination for beauty and self-care",
                })}
              />
              <div className={"ctas-container"}>
                <Button
                  primary={true}
                  as={OutboundLink}
                  to={bookingUrl.url}
                  event={{
                    category: "Booking",
                    action: "Schedule Appointment Intent",
                  }}
                  icon={<FishermanIcon iconName={"arrow-right"} />}
                  labelPosition={"right"}
                  content={bookingUrl.title}
                />
              </div>
            </BackgroundImages>
          </AnimatedSelector>
          <Section className={"services-section"}>
            <Header
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_header",
                defaultValue: "Discover Services",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
            />
            <Accordion exclusive={true} className={"services-accordion"}>
              <MultipleComponentIterator
                iterator={allFishermanBusinessMenuCategory.nodes}
                limit={4}
                components={[
                  {
                    component: <React.Fragment />,
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: (
                          <Accordion.Title
                            activeIcon={"minus"}
                            inactiveIcon={"plus"}
                          />
                        ),
                        propMap: { index: "__itemIndex__" },
                        children: [
                          {
                            component: <Header as={"h2"} />,
                            children: [
                              {
                                component: <span />,
                                propMap: { children: "name" },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        component: <Accordion.Content />,
                        propMap: { index: "__itemIndex__" },
                        children: [
                          {
                            component: (
                              <Grid
                                className={"main content"}
                                doubling={true}
                                stackable={true}
                                columns={2}
                              />
                            ),
                            children: [
                              {
                                component: (
                                  <Grid.Column
                                    className={"services"}
                                    width={8}
                                  />
                                ),
                                children: [
                                  {
                                    component: <Grid />,
                                    children: [
                                      {
                                        component: (
                                          <MultipleComponentIteratorMap
                                            lookupField={"_id"}
                                            limit={4}
                                            iterator={
                                              allFishermanBusinessMenuItem.nodes
                                            }
                                            components={[
                                              {
                                                component: (
                                                  <Grid.Column width={16} />
                                                ),
                                                children: [
                                                  {
                                                    component: (
                                                      <InternalLink
                                                        event={{
                                                          category: "Services",
                                                          action:
                                                            "View Item Details",
                                                        }}
                                                      />
                                                    ),
                                                    propMap: {
                                                      "event.label": "name",
                                                      to: withArgs({
                                                        func: createServiceItemSlug,
                                                        args: [
                                                          allFishermanBusinessMenuCategory.nodes,
                                                        ],
                                                      }),
                                                    },
                                                    children: [
                                                      {
                                                        component: (
                                                          <Header as={"h3"} />
                                                        ),
                                                        propMap: {
                                                          children: "name",
                                                        },
                                                      },
                                                    ],
                                                  },
                                                ],
                                              },
                                            ]}
                                          />
                                        ),
                                        propMap: { targetValues: "items" },
                                      },
                                    ],
                                  },
                                ],
                              },
                              {
                                component: (
                                  <Grid.Column
                                    className={"category-images"}
                                    width={8}
                                  />
                                ),
                                children: [
                                  {
                                    component: (
                                      <BasicCarousel
                                        size={1}
                                        displayIndicators={false}
                                        displayPlayPauseButton={false}
                                        autoScroll={false}
                                        leftArrowIcon={"arrow-left"}
                                        rightArrowIcon={"arrow-right"}
                                        animation={{
                                          name: "blur",
                                          duration: 200,
                                          transitionProps: {
                                            preAnimating: {
                                              opacity: 0.99,
                                              blur: "2px",
                                            },
                                            animating: {
                                              opacity: 0.99,
                                              blur: "2px",
                                            },
                                          },
                                        }}
                                      />
                                    ),
                                    propMap: {
                                      items: withNamedArgs({
                                        func: componentIterator,
                                        args: {
                                          iterator: withNamedArgs({
                                            func: getBusinessFiles,
                                            args: {
                                              businessFiles:
                                                allFishermanBusinessFile.nodes,
                                            },
                                          }),
                                          component: (
                                            <Image background={true} />
                                          ),
                                          propMap: { src: "__all__" },
                                        },
                                      }),
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            component: <div className={"button-container"} />,
                            children: [
                              {
                                component: (
                                  <Button
                                    basic={true}
                                    event={{
                                      category: "Services",
                                      action: "View Category Details",
                                    }}
                                    as={InternalLink}
                                    icon={
                                      <FishermanIcon iconName={"arrow-right"} />
                                    }
                                    content={"See All"}
                                    labelPosition={"right"}
                                  />
                                ),
                                propMap: {
                                  "event.label": "name",
                                  to: createServiceCategorySlug,
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ]}
              />
            </Accordion>
            <div className={"see-all-offering-button-container"}>
              <Button
                basic={true}
                icon={true}
                event={{ category: "Services", action: "View Services" }}
                as={InternalLink}
                to={"/services/"}
              >
                <span
                  children={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "see_all_services_button",
                    defaultValue: "See Full Service Offering",
                  })}
                />
                <FishermanIcon iconName={"arrow-right"} />
              </Button>
            </div>
          </Section>
          <Section className={"about-section"}>
            <Grid stackable={true} doubling={true} columns={2}>
              <Grid.Column width={8} className={"markdown-column"}>
                <div>
                  <FadeReveal duration={1250} triggerOnce={true}>
                    <Header
                      as={"h2"}
                      className={"section-header"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_header",
                        defaultValue: "Our Story",
                      })}
                    />
                    <MarkdownContent
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_description",
                      })}
                    />
                    <div className={"ctas-container"}>
                      <Button
                        secondary={true}
                        as={OutboundLink}
                        to={bookingUrl.url}
                        event={{
                          category: "Booking",
                          action: "Schedule Appointment Intent",
                        }}
                      >
                        {bookingUrl.title}
                      </Button>
                    </div>
                  </FadeReveal>
                </div>
              </Grid.Column>
              <Grid.Column width={8} className={"images-column"}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <BasicCarousel
                    size={1}
                    displayIndicators={false}
                    displayPlayPauseButton={false}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    slide={true}
                    items={componentIterator({
                      iterator: getComponentFiles({
                        components: fishermanBusinessWebsitePage.components,
                        componentName: "ImageCollection",
                        componentIdentifier: "about_section_image_gallery",
                      }),
                      component: <Image background={true} />,
                      propMap: { src: "__all__" },
                    })}
                  />
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"stylists-section"}>
            <Header
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "staff_section_header",
                defaultValue: "Featured Team Members",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "staff_section_description",
              })}
            />
            <Card.Group className={"stylists"} itemsPerRow={4}>
              <MultipleComponentIterator
                iterator={allFishermanBusinessTeam.nodes}
                limit={4}
                components={[
                  {
                    component: (
                      <SlideReveal
                        className={"ui card"}
                        fade={true}
                        direction={"up"}
                        triggerOnce={true}
                      />
                    ),
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: (
                          <BackgroundImageTeamMember
                            useModal={false}
                            as={InternalLink}
                            moreInfoIconName={"arrow-right"}
                          />
                        ),
                        propMap: {
                          "teamMember.name": "name",
                          "teamMember.role": "role",
                          "teamMember.photo": "gatsbyImage",
                          "teamMember.description": "description",
                          "teamMember.email": "email",
                          "teamMember.phone": "phone",
                          "teamMember.locations": "locations",
                          "teamMember.hours": "hours",
                          "teamMember.social": "socialMedia",
                          to: createTeamMemberSlug,
                        },
                      },
                    ],
                  },
                ]}
              />
            </Card.Group>
            <div className={"see-all-stylists-button-container"}>
              <Button
                basic={true}
                icon={true}
                event={{ category: "Team", action: "View All Team Members" }}
                as={InternalLink}
                to={"/team/"}
              >
                <span
                  children={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "see_all_team_button",
                    defaultValue: "See All Team Members",
                  })}
                />
                <FishermanIcon iconName={"arrow-right"} />
              </Button>
            </div>
          </Section>
          <Section className={"trusted-by-section"}>
            <Grid stackable={true} columns={2}>
              <Grid.Column width={5} className={"copy-column"}>
                <Header
                  as={"h2"}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "trusted_by_section_header",
                    defaultValue: "Trusted By:",
                  })}
                />
              </Grid.Column>
              <Grid.Column width={11} className={"images-column"}>
                <BasicCarousel
                  className={"image-gallery"}
                  size={4}
                  mobile={{ displayAll: true, displayAllColumns: 1 }}
                  displayIndicators={false}
                  displayPlayPauseButton={false}
                  autoScroll={true}
                  leftArrowIcon={"arrow-left"}
                  rightArrowIcon={"arrow-right"}
                  animation={{
                    name: "blur",
                    duration: 200,
                    transitionProps: {
                      preAnimating: { opacity: 0.99, blur: "2px" },
                      animating: { opacity: 0.99, blur: "2px" },
                    },
                  }}
                  items={componentIterator({
                    iterator: getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "ImageCollection",
                      componentIdentifier: "trusted_by_image_gallery",
                    }),
                    component: <Image background={true} />,
                    propMap: { src: "__all__" },
                  })}
                />
              </Grid.Column>
            </Grid>
          </Section>
          <div
            className={"elfsight-app-6824152f-6c9a-40c9-b65a-1e315f59fa74"}
            data-elfsight-app-lazy={true}
          />
          <Section className={"reviews-section"}>
            <Header
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "reviews_section_header",
                defaultValue: "What Our Clients Say",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "reviews_section_description",
              })}
            />
            <BasicCarousel
              className={"reviews-carousel faded-sides-carousel"}
              size={3}
              displayIndicators={false}
              stepSize={1}
              autoScroll={false}
              leftArrowIcon={"arrow-left"}
              rightArrowIcon={"arrow-right"}
              displayPlayPauseButton={false}
              slide={true}
              items={multipleComponentIterator({
                iterator: fishermanBusiness.reviews,
                components: [
                  {
                    component: <ReviewV2 />,
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: <ReviewV2.Image />,
                        propMap: { src: "image" },
                        children: [
                          {
                            component: (
                              <FishermanIcon iconName={"quote-left"} />
                            ),
                          },
                        ],
                      },
                      {
                        component: <ReviewV2.Text charLimit={360} />,
                        propMap: { text: "text" },
                      },
                      {
                        component: <ReviewV2.Line />,
                        children: [
                          {
                            component: <ReviewV2.Rating />,
                            propMap: { rating: "rating" },
                          },
                          {
                            component: <ReviewV2.RatingLabel />,
                            propMap: { rating: "rating" },
                          },
                        ],
                      },
                      {
                        component: <ReviewV2.Line />,
                        children: [
                          {
                            component: <ReviewV2.Author />,
                            propMap: { author: "author" },
                          },
                          {
                            component: <ReviewV2.Source />,
                            propMap: { source: "source", link: "link" },
                          },
                        ],
                      },
                    ],
                  },
                ],
              })}
            />
            <CustomerReviewModal
              businessId={fishermanBusiness._id}
              locations={allFishermanBusinessLocation.nodes}
              businessType={fishermanBusiness.type}
              triggerButtonProps={{
                basic: true,
                labelPosition: "right",
                icon: <FishermanIcon iconName={"arrow-right"} />,
              }}
              buttonText={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "submit_review_button",
                defaultValue: "Submit Review",
              })}
            />
          </Section>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      reviews {
        _id
        author
        text
        source
        rating
        link
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          content
        }
      }
      seoTitle
    }
    bookingUrl: fishermanBusinessWebsitePage(
      title: { regex: "/Book Now|Make An Appointment/" }
      pageType: { eq: "External" }
    ) {
      url
      title
    }
    allFishermanBusinessMenuCategory(
      sort: { fields: [isFeatured, order], order: [DESC, ASC] }
    ) {
      nodes {
        _id
        description
        name
        items
        files
      }
    }
    allFishermanBusinessMenuItem(
      sort: { fields: [isFeatured, order], order: [DESC, ASC] }
      filter: { visible: { eq: true } }
    ) {
      nodes {
        _id
        name
        description
        image
        visible
        available
        files
        variations {
          price
        }
      }
    }
    allFishermanBusinessFile {
      nodes {
        _id
        file
        description
        gatsbyFile {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
    allFishermanBusinessTeam(
      sort: { order: ASC, fields: order }
      filter: { show: { eq: true } }
    ) {
      nodes {
        _id
        name
        role
        group
        email
        phone
        description
        image
        gatsbyImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        socialMedia {
          platform
          url
        }
        hours {
          startDay
          openTime
          closeTime
        }
        locations {
          _id
          name
        }
        show
      }
    }
    allFishermanBusinessLocation {
      nodes {
        _id
        street
        city
        name
        phoneNumber
        primaryLocation
      }
    }
  }
`;
